import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GButton from "components/ui/button/Button";
import GModal from "components/ui/modal/Modal";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  addIngerdiants,
  getIngerdiants,
  getIngerdiantsDrop,
} from "../../services/ingrediantsService";

const AddIngrediantsModal = ({ onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { handleSubmit, setValue } = useForm();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });
  const id = useParams();

  const itemTags = useSelector((state) => state.ingrediants);

  useEffect(() => {
    dispatch(getIngerdiantsDrop());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.ingrediants.add_ingrediants")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.ItemsIngredient = values.ItemsIngredient?.map((e) => ({
                IngredientId: e.InventoryItemId,
                InventoryItemId: id.itemId,
              }));
              values.UserId = localStorage.getItem("userId");
              if (
                values.ItemsIngredient === undefined ||
                values.ItemsIngredient.length === 0
              ) {
                toast2({
                  description: t("pages.DailyRestrictions.searchvalidation"),
                });
              } else {
                dispatch(addIngerdiants(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t("pages.transfers_orders.items_added"),
                    });
                    dispatch(getIngerdiants(id.itemId));
                    onClose();
                  });
              }
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("pages.ingrediants.ingrediants")}
                data={
                  itemTags.data1 &&
                  itemTags.data1.map((el) => ({
                    ...el,
                    label: el.InventoryItemNameEng,
                    value: el.InventoryItemId,
                  }))
                }
                isMulti={true}
                isRequired={true}
                onChange={(e) => setValue("ItemsIngredient", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("pages.inventory_item_details.apply")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={itemTags.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={itemTags.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default AddIngrediantsModal;
